import {
  IsNotEmpty,
  IsIn,
  IsNumber,
  IsArray,
  ValidateNested,
  IsOptional,
  IsBoolean,
} from "class-validator";
import { Type } from "class-transformer";

import { Constants } from "@river/constants";

import { IAdapterAutoScheduleAction } from "./adapter-auto-schedule-action.interface";
import { IAsObjective } from "./adapter-auto-schedule.interface";

// ------------------
export class AsObjectiveDto implements IAsObjective {
  //
  @IsNotEmpty()
  @IsIn(Object.values(Constants.auto_schedule_objective))
  solve_target: string;

  @IsNotEmpty()
  @IsNumber()
  weight: number;
}

// ------------------
export class AdapterAutoScheduleActionDto implements IAdapterAutoScheduleAction {
  @IsNotEmpty()
  folder_id: string;

  @IsOptional()
  @IsIn(Object.values(Constants.auto_schedule_job_grouping_mode))
  job_grouping_mode?: string; // default workorder. Determines the job grouping level for the auto-scheduler (workorder or func_location/equipment).

  @IsOptional()
  @IsBoolean()
  preserve_committed_records?: boolean;

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => AsObjectiveDto)
  objectives: AsObjectiveDto[];

  @IsOptional()
  @IsBoolean()
  allow_capacity_slack?: boolean; // Allow downward capacity slack, default false

  @IsOptional()
  @IsBoolean()
  allow_positive_capacity_slack?: boolean; //Allow upward capacity slack, default false

  @IsOptional()
  @IsNumber()
  capacity_slack_weight?: number; // Weight for downward slack in objective, default 1.0

  @IsOptional()
  @IsNumber()
  positive_capacity_slack_weight?: number; // Weight for upward slack in objective, default 10.0

  @IsOptional()
  @IsNumber()
  positive_capacity_ceiling_add?: number; // Additional capacity ceiling for upward slack, default 0
}
